<script>
	import calendarize from 'calendarize'
	import tinydate from 'tinydate'
	import { slide } from 'svelte/transition'
	import { cubicOut, cubicInOut } from 'svelte/easing'
	const stamp = tinydate('{YYYY}{MM}')
	const todayStamp = tinydate('{YYYY}{MM}{DD}')
	let date = new Date()

	//empty array that is ready to receive data (export)
	export let events = []
	// console.log('events:', events)

	//create empty object for start dates
	let eventDates = {}

	let activeEvents = events

	// function classActive() {
	// 	$(this).addClass('active')
	// }

	let classActive

	//loop events
	events.forEach(event => {
		//let time = event.time
		let { time } = event
		time.forEach(newTime => {
			if (!eventDates[newTime]) {
				eventDates[newTime] = []
			}
			eventDates[newTime].push(event)
		})
		//let eventDates with the key of time equal event
		// eventDates[time] = event
	})

	//get the keys of start eventDates
	let eventDatesArr = Object.keys(eventDates)

	// width of calendar
	let width

	// ex 20201001
	let today = todayStamp(date)

	let daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S']

	$: monthHeading = date.toLocaleString('en-US', {
		month: 'long',
	})

	$: yearMonth = stamp(date)

	$: calWeeks = calendarize(date)

	// eg 202002
	function subtractMonth() {
		date.setMonth(date.getMonth() - 1, 1)
		date = new Date(date)
	}
	function addMonth() {
		date.setMonth(date.getMonth() + 1, 1)
		date = new Date(date)
	}
</script>

<div
	class="calendar calendar-section"
	bind:offsetWidth={width}
	in:slide={{ duration: 750, easing: cubicInOut }}
	out:slide={{ duration: 750, easing: cubicOut }}>
	<div class="main">
		<div class="header calrow flex-middle">
			<div class="calcol calcol-start">
				<button class="icon prev" on:click={subtractMonth}>
					<svg viewBox="0 0 478 478">
						<path d="M132 0l-32 32 214 207-214 207 32 32 246-239z" />
					</svg>
					<span class="sr-only">Previous Month</span>
				</button>
			</div>
			<div class="calcol calcol-center">
				<span>{monthHeading}</span>
			</div>
			<div class="calcol calcol-end">
				<button class="icon" on:click={addMonth}>
					<svg viewBox="0 0 478 478">
						<path d="M132 0l-32 32 214 207-214 207 32 32 246-239z" />
					</svg>
					<span class="sr-only">Previous Month</span>
				</button>
			</div>
		</div>

		<div class="days calrow">
			{#each daysOfWeek as dayName}
				<div class="calcol calcol-center">
					{width > 700 ? dayName : dayName.substr(0, 3)}
				</div>
			{/each}
		</div>
		<div class="calbody">
			{#each calWeeks as week}
				<div class="calrow">
					{#each week as day}
						<!-- If the eventDatesArr object key matches the current date string add num-event class -->
						<!-- <div
						class="calcol cell"
						class:num-event={eventEndDatesArr.indexOf(`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`) > -1}> -->
						<div
							class="calcol cell"
							class:num-event={eventDates[`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`]}>
							<!-- ^ concatenates yearMonth with Day, if length of day is less than 2 add a trailing zero to maintain date format. indexOf is greater than -1, array starts at 0, false = 0, true = 1, helps prevent falsy values? -->
							{#if day}
								<div class="cal-number-dots-wrap">
									<span
										class="number"
										class:num-today={`${yearMonth}${String(day).length < 2 ? `0${day}` : day}` === today}>
										{day}
									</span>
									{#if eventDatesArr.indexOf(`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`) > -1}
										<div class="cal-dots-wrap">
											{#each eventDates[`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`] as event}
												<span
													class="cal-dots"
													style="background-color: {event.cat[0].color};" />
											{/each}
										</div>
									{/if}
								</div>
								<!-- If eventDatesArr object key matches the current day, get the eventDates key title -->
								{#if eventDatesArr.indexOf(`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`) > -1}
									<span class="event-title">
										{#each eventDates[`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`] as event}
											<span class="title-block">
												<a href={event.link} class="title-link">
													{event.title}
												</a>
											</span>
										{/each}
										<!-- {eventDates[`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`].title} -->
									</span>
									<a
										href="/calendar/"
										class="cal-main-link"
										on:click={e => {
											e.preventDefault()
											activeEvents = eventDates[`${yearMonth}${String(day).length < 2 ? `0${day}` : day}`]
										}}>
										<span class="sr-only">View Calendar</span>
									</a>
								{/if}
							{/if}
						</div>
					{/each}
				</div>
			{/each}
		</div>
	</div>
</div>

{#if activeEvents.length}
	<div class="cal-events-grid">
		<h2 class="cal-events-header">All Events</h2>
		{#each activeEvents as event}
			<div class="util-cat-wrap mobile-cat-wrap">
				{#each event.cat as cat}
					<a
						href={cat.url}
						class="util-cat-link"
						style="background-color:{cat.color}; border: 2px solid {cat.color};">
						{cat.name}
					</a>
				{/each}
			</div>
			<div
				class="cal-event-item"
				style="color: {event.cat[0].color}; background-color: {event.cat[0].color};">
				<div class="util-cat-wrap">
					{#each event.cat as cat}
						<a
							href={cat.url}
							class="cal-cat-link"
							style="background-color:{cat.color}; border: 2px solid {cat.color};">
							{cat.name}
						</a>
					{/each}
				</div>
				<div
					class="cal-event-img"
					class:cal-event-img-fallback={!event.img}
					style="background-image:url({event.img ? event.img : event.fallbackImg})" />
				<div class="cal-event-content">
					<h3>{event.title}</h3>
					<div class="cal-time-wrap">
						<p class="cal-event-time">
							{#if event.unFormattedtime.length == 1}
								Event Date:
							{:else}Event Dates:{/if}
							<time>{event.unFormattedtime}</time>
						</p>
					</div>
					<p>
						{@html event.content}
					</p>
				</div>
				<a href={event.link} class="cal-post-link">
					<span class="sr-only">{event.title}</span>
				</a>
			</div>
		{/each}
	</div>
{/if}
